import sortable from "sortablejs";

const createSortable = (el, options, vnode) =>
  sortable.create(el, {
    ...options,
  });

export const sortableRow = {
  name: "sortableRow",
  bind(el, binding, vnode) {
    const table = el;
    table._sortable = createSortable(
      table.querySelector("tbody"),
      binding.value,
      vnode
    );
  },
};

export const sortableCol = {
  name: "sortableCol",
  bind(el, binding, vnode) {
    const table = el;
    table._sortable = createSortable(
      table.querySelector("tr"),
      binding.value,
      vnode
    );
  },
};
